import { DashboardViewService } from './DashboardViewService';
import {
  DashboardData,
  DashboardDataReceipts,
  DashboardDataStatus,
} from '../dashboardViewSlice/types';
import { data } from './mockData';

export const DashboardViewServiceImpl: DashboardViewService = {
  getDashboardData: async (): Promise<DashboardData> => {
    // return axios
    //     .get<GoogleUserInfo>(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${accessToken}`, {
    //         headers: {
    //             Authorization: `Bearer ${accessToken}`,
    //             Accept: 'application/json'
    //         }
    //     })
    //     .then((user) => {
    //         return user.data;
    //     })
    return Promise.resolve(data);
  },
};
